import { render, staticRenderFns } from "./ModalStaffEventDetails.vue?vue&type=template&id=067b92b6&scoped=true&"
import script from "./ModalStaffEventDetails.vue?vue&type=script&lang=ts&"
export * from "./ModalStaffEventDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067b92b6",
  null
  
)

export default component.exports